export const UNHANDLED_EXCEPTION: string = 'UNHANDLED_EXCEPTION';

export const DEFAULT_PAGINATION_SIZES: number[] = [30, 50, 100];

export const GENERIC_SERVER_ERROR_TRANSLATION = 'notification.generic.server.error';

export const TIMEOUT_ERROR_TRANSLATION = 'notification.timeout.server.error';

export const DEFAULT_LANGUAGE = 'en_US';

export const TRANSLATION_NAMESPACES = [
    'translations-commons',
    'translations-devices',
    'translations-global',
    'translations-operators',
    'translations-settings',
    'translations-trainings',
] as const;

export const DEFAULT_LONG_TIMEOUT_SLOW_REQUEST = 2000;

export const DEFAULT_FILTER_SEARCH_DEBOUNCE = 300;

export const PRODUCT_NAME = 'POC Operations';

export const PRODUCT_DESCRIPTION = 'Advanced POC modules';

export const API_ERROR_DUPLICATED_REQUEST = 'DUPLICATED';

export const API_ERROR_TIMEOUT = 'TIMEOUT';

export const appRoles = {
    POCC_ADMIN: 'pocc-admin',
    POCC: 'pocc',
};

export const DROPDOWN_SEARCH_MIN_CHARACTERS_ALLOWED = 1;

export const MAX_OPTIONS_WITHOUT_SEARCH = 9;

export const DEFAULT_HOVER_DELAY = 200;
